import { useSyncExternalStore } from "react"

import { getAuthGeneration, subscribeAuthGeneration } from "@/api/auth-refresh-coordinator"

/**
 * The auth session generation. Put it last in the query key of data scoped to
 * the signed-in principal, so a session change (for example another tab
 * replacing the Easy Auth cookie) refetches instead of showing the previous
 * principal's cached rows. Last, so prefix invalidation keeps matching.
 */
export function useAuthGeneration(): number {
  return useSyncExternalStore(subscribeAuthGeneration, getAuthGeneration, getAuthGeneration)
}
